export default __webpack_public_path__ + "static/media/desktop-hero-portugese.d3a5a343.svg";